import catalogSettingsModule from "@/store/pharma-cpc-mgmt/catalog_settings";
import discountSchemeModule from "@/store/pharma-cpc-mgmt/discount_scheme";
import shoppingCartDiscountPriceListModule from "@/store/pharma-cpc-mgmt/shopping_cart_discount_scheme";
import priceListModule from "@/store/pharma-cpc-mgmt/price_list";
import productFiltersModule from "@/store/pharma-cpc-mgmt/product_filters";
import starterSettingsModule from "@/store/pharma-cpc-mgmt/starter_settings";

export default {
    namespaced: true,
    modules: {
        catalog_settings: catalogSettingsModule,
        discount_scheme: discountSchemeModule,
        shopping_cart_discount_scheme: shoppingCartDiscountPriceListModule,
        price_list: priceListModule,
        product_filters: productFiltersModule,
        starter_settings: starterSettingsModule,
    },
    state() {
        return {
            search_brand_name: undefined as string | undefined,
            search_trademark_name: undefined as string | undefined,
            search_product: {
                brand_name: undefined as string | undefined,
                trademark_name: undefined as string | undefined,
                cnk_code: undefined as string | undefined,
                product_name: undefined as string | undefined,
                is_medicine: false as boolean,
                is_medical_aid: false as boolean,
                is_prescription_required: false as boolean,
                usage_type_code: undefined as string | undefined,
            } as object,
        }
    },
    actions: {
        clearSearchBrandName(context: any) {
            context.commit('setSearchBrandName', undefined);
        },
        clearSearchTrademarkName(context: any) {
            context.commit('setSearchTrademarkName', undefined);
        },
        clearSearchProduct(context: any, property?: string) {
            if (property) {
                context.commit('setSearchProductProperty', {
                    property: property,
                    value: property.startsWith('is') ? false : undefined,
                });
            } else {
                context.commit('setSearchProduct', {
                    brand_name: undefined,
                    trademark_name: undefined,
                    cnk_code: undefined,
                    product_name: undefined,
                    is_medicine: false,
                    is_medical_aid: false,
                    is_prescription_required: false,
                    usage_type_code: undefined,
                });
            }
        },
        setSearchBrandName(context: any, search_text: string) {
            context.commit('setSearchBrandName', search_text);
        },
        setSearchTrademarkName(context: any, search_text: string) {
            context.commit('setSearchTrademarkName', search_text);
        },
        setSearchProductProperty(context: any, payload: any) {
            context.commit('setSearchProductProperty', payload);
        },
    },
    mutations: {
        setSearchBrandName(state: any, search_text: string) {
            state.search_brand_name = search_text;
        },
        setSearchTrademarkName(state: any, search_text: string) {
            state.search_trademark_name = search_text;
        },
        setSearchProduct(state: any, payload: any) {
            for (const search_product_prop in state.search_product) {
                if (search_product_prop in payload) {
                    state.search_product[search_product_prop] = payload[search_product_prop];
                }
            }
        },
        setSearchProductProperty(state: any, payload: any) {
            state.search_product[payload.property] = payload.value;
        },
    },
    getters: {
        getSearchBrandName(state: any): string {
            return state.search_brand_name;
        },
        getSearchTrademarkName(state: any): string {
            return state.search_trademark_name;
        },
        getSearchProduct(state: any): object {
            return state.search_product;
        },
    },
}
